import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setScanPrintToggleStatus } from "../../../redux/slices/ScanPrint/ScanPrintslice";

function ToggleDetails() {
  const dispatch = useDispatch();
  const Status = useSelector((state) => state.scan.ScanPrintStatsToggleStatus);

  return (
    <div className="flex items-center justify-center w-full mt-8 mb-6">
      <label htmlFor="toggleB" className="flex items-center">
        <div className="relative">
          <input id="toggleB" className="sr-only" />
            <div className="block bg-cyan-100 w-64 h-10 rounded-full">
              <div className="flex flex-row justify-center space-x-3 pt-3">
                <p
                  onClick={() => dispatch(setScanPrintToggleStatus("Scan Barcode"))}
                  className=" text-xs font-semibold text-gray-900 font-Montserrat  cursor-pointer"
                >
                 Scan Barcode
                </p>
                
                <p
                  onClick={() => dispatch(setScanPrintToggleStatus("Print barcodes"))}
                  className=" pl-3 text-xs font-semibold text-gray-900 font-Montserrat  cursor-pointer"
                >
                  Print barcodes
                </p>
              </div>
            </div>
              {Status === "Scan Barcode" ? (
                <div className="absolute left-3 top-1 bg-white w-28 h-8 rounded-full transition shadow-md text-xs font-semibold text-blue-100 font-Montserrat text-center pt-2">
                 Scan Barcode
                </div>
              ) : null}
             
              {Status === "Print barcodes" ? (
                <div className="absolute left-32 top-1 bg-white w-28 h-8 rounded-full transition shadow-md text-xs font-semibold text-blue-100 font-Montserrat text-center pt-2">
                  Print barcodes
                </div>
              ) : null}
        </div>
      </label>
    </div>
  );
}

export default ToggleDetails;
